import React, { Fragment, useContext, useEffect, useState } from "react";
import { Image, Header, Button } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoginForm from "../../user/LoginForm";
import { history } from "../../..";

const HomePage = () => {
  const rootStore = useContext(RootStoreContext);
  const { isLoggedIn, user } = rootStore.userStore;

  const [cookiesMessageVisible, setCookiesMessageVisible] =
    useState<boolean>(true);

  useEffect(() => {
    setCookiesMessageVisible(window.localStorage.getItem("consent") !== "true");
  }, [setCookiesMessageVisible]);

  if (process.env.REACT_APP_UNDER_MAINTENANCE === "true") {
    history.push("/manutencao");
  }

  if (isLoggedIn && user) {
    if (user.role === "Admin" || user.role === "Manager" || user.role === "Teacher") {
      history.push("/admin/dashboard");
    } else {
      history.push("/aluno/dashboard");
    }
  }

  return (
    <Fragment>
      <div style={{ width: "100%" }}>
        <div
          style={{
            float: "left",
            maxWidth: "50%",
            width: "auto",
            height: "auto",
            boxSizing: "border-box"
            // position: "fixed"
          }}
        >
          <Image
            src="/assets/66901c5f0e1728744427765-bg.png"
            style={{ width: "100%" }}
          />
        </div>
        <div
          style={{
            width: "30%",
            position: "absolute",
            top: "30%",
            left: "60%",
          }}
        >
          <Header as="h1" content="" textAlign="center" />
          <LoginForm />
        </div>
      </div>
      {cookiesMessageVisible && (
        <div className="InitialCookiesMessage">
          Este site faz o uso de cookies e ao continuar navegando você consente
          da utilzação dos mesmos.{" "}
          <Button
            style={{ marginLeft: "10px" }}
            content="OK"
            circular
            primary
            color="google plus"
            onClick={() => {
              window.localStorage.setItem("consent", "true");
              setCookiesMessageVisible(false);
            }}
          />
        </div>
      )}
    </Fragment>
  );
};

export default HomePage;
